export const CONFIGURATION_INPUT = 'CONFIGURATION_INPUT' as const;
export const CONFIGURATION_OUTPUT = 'CONFIGURATION_OUTPUT' as const;
